import React, { useEffect, useRef, useState } from 'react'
import { Table, Row, Col, Card, CardBody, Container, Button } from 'reactstrap';
import { TablePagination } from '../../Components/Pagination'
import { getAllProducts, getCarrefourScrapeListById, getCategoryData, getChildCategoryData, getParentCategoryData } from '../../API/Backend';
import { showToast } from '../../Components/Toast';
import { Link } from 'react-router-dom';
import { CarrefourModal } from '../../Components/Modal';
import Modal from "react-modal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { InputText } from 'primereact/inputtext';
import { get } from '../../Utilities/Requests';
import { MultiSelect } from 'primereact/multiselect';


export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [matchFilter, setMatchFilter] = useState("matched");
  const [detailTableLoading, setDetailTableLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [technicalDetails, setTechnicalDetails] = useState({});
  const [parentCategoryData, setParentCategoryData] = useState([]);
  const [childCategoryData, setChildCategoryData] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
    sortField: "title",
    sortOrder: 1,
    global: "",
    filters: {
      global: { value: "", matchMode: 'contains' },
      title: { value: null, matchMode: 'contains' },
      amazonPrice: { value: null, matchMode: 'equals' },
      carrefourPrice: { value: null, matchMode: 'equals' },
      savings: { value: null, matchMode: 'equals' },
      category: { value: null, matchMode: 'contains' },
      parentId: { value: null, matchMode: "in" },
      categoryId: { value: null, matchMode: 'in' }
    }
  });


  useEffect(() => {
    getParentCategoryData().then(({ data }) => {
      if (data.data) {
        const categories = data.data.map(c => ({ title: c.title, value: c._id }));
        setParentCategoryData(categories);
      }
    });

    getChildCategoryData().then(({ data }) => {
      if (data.data) {
        const categories = data.data.map(c => ({ title: c.title, value: c._id }));
        setChildCategoryData(categories);
      }
    });

  }, []);


  useEffect(() => {
    fetchProducts(lazyParams, matchFilter);
  }, [lazyParams, matchFilter]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setLazyParams((prev) => ({
      ...prev,
      first: 0,
      filters: {
        ...prev.filters,
        global: { value, matchMode: "contains" }
      }
    }));
  };


  const fetchProducts = (req, mf = matchFilter) => {
    const request = {
      ...req,
      ...(mf !== "all" && { matched: mf === "matched" }),
      filters: JSON.stringify(req.filters)
    };

    setLoading(true);
    setProducts([])
    getAllProducts(request).then(({ data }) => {
      if (data.data) {
        data.data.products.forEach(p => {
          if (p.carrefourPrice && p.amazonPrice) {
            p.savings = p.carrefourPrice > p.amazonPrice ? ((p.carrefourPrice - p.amazonPrice) * 100 / p.carrefourPrice).toFixed(2) : ((p.amazonPrice - p.carrefourPrice) * 100 / p.amazonPrice).toFixed(2);
          } else {
            p.savings = 0;
          }
        });
        setProducts(data.data ? data.data.products : [])
        setCount(data.data ? data.data.count : 0)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const fetchCarrefourScrapeProductsById = (id) => {
    setDetailTableLoading(true);
    setModalVisible(true);
    setSelectedItem([]);
    getCarrefourScrapeListById(id).then(({ data }) => {
      if (data.data && data) {
        data.data.forEach(p => p._id = id);
        data.data[0].item.isBestMatch = true; // mark the first item as best match

        // const minScore = Math.min(...data.data.map(p => p.score));
        // data.data.filter(p => p.score === minScore).forEach(p => p.item.isBestMatch = true);
        // console.log(data.data);
        setSelectedItem(data.data);
        setDetailTableLoading(false);
      }
      else {
        showToast("warning", "Product", data.message)
        setDetailTableLoading(false);
      }
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setDetailTableLoading(false)
    })
  }

  const openModal = (item) => {
    fetchCarrefourScrapeProductsById(item._id);
  };


  const openDetailModal = (item) => {
    setTechnicalDetails(item);
    setVisible(true);
  };

  const onPage = (event) => {
    setLazyParams(prev => ({
      ...prev,
      ...event,
      sortField: event.sortField || prev.sortField || "title",
      sortOrder: event.sortOrder || prev.sortOrder || 1
    }));
  };

  const onSort = (event) => {
    setLazyParams(prev => ({
      ...prev,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    }));
  };

  const onFilter = (event) => {
    setLazyParams(prev => ({
      ...prev,
      filters: event.filters,
      first: 0
    }));
  };
  ;

  const handleExport = () => {

    const formattedData = products.map(item => ({
      Product: item.title,
      Category: item.categoryId?.parentId?.title || "",
      SubCategory: item.categoryId?.title || "",
      AmazonPrice: item.amazonPrice,
      CarrefourPrice: item.carrefourPrice,
      Savings: item.savings + "%"
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(data, "Products.xlsx");
  };


  const representativeRowFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={parentCategoryData}
        itemTemplate={(option) => <span>{option.title}</span>}
        onChange={(e) => options.filterApplyCallback(e.value)}
        optionLabel="title"
        placeholder="Any"
        filter="true"
        className="p-column-filter"
        maxSelectedLabels={1}
        style={{ minWidth: '14rem' }}
      />
    );
  };


  const representativeSubCategoryFilterTemplate = (options) => {
    return (
      <MultiSelect
        value={options.value}
        options={childCategoryData}
        itemTemplate={(option) => <span>{option.title}</span>}
        onChange={(e) => options.filterApplyCallback(e.value)}
        optionLabel="title"
        placeholder="Any"
        className="p-column-filter"
        filter="true"
        clearIcon="pi pi-filter-slash"
        showClear="true"
        maxSelectedLabels={1}
        style={{ minWidth: '14rem' }}
      />
    );
  };

  const header = (
    <div className="flex align-items-center gap-3">

      {/* Search */}
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={lazyParams.filters.global.value || ''}
          onChange={onGlobalFilterChange}
          placeholder="Search by name…"
        />
      </span>

      {/* Matched / Unmatched toggle */}
      <select
        className="form-select form-select-sm"
        style={{ width: 150 }}
        value={matchFilter}
        onChange={(e) => { setMatchFilter(e.target.value); setLazyParams((p) => ({ ...p, first: 0 })); }}
      >
        <option value="matched">Matched</option>
        <option value="unmatched">Unmatched</option>
        <option value="all">All Products</option>
      </select>

      {/* Export Button */}
      <button
        className="btn btn-success btn-sm" style={{ float: 'right' }}
        onClick={handleExport}
      >
        <i className="ri-file-excel-2-fill me-1"></i> Export
      </button>

    </div>
  );


  return (
    <Container fluid>
      <Row className="align-items-center mb-3">
        <Col>
          <h5 className="page-title">Product Management</h5>
          <Card className="">
            <CardBody>
              <Row>
                <DataTable
                  value={products}
                  lazy
                  loading={loading}
                  first={lazyParams.first}
                  rows={lazyParams.rows}
                  paginator
                  onPage={onPage}
                  onSort={onSort}
                  sortOrder={lazyParams.sortOrder}
                  sortField={lazyParams.sortField}
                  filters={lazyParams.filters}
                  onFilter={onFilter}
                  totalRecords={count}
                  emptyMessage="No products found"
                  sortMode="single"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  filterDisplay="row"
                  header={header}
                >

                  {/* Image Column */}
                  <Column
                    header="Image"
                    style={{ width: "5%" }}

                    body={(rowData) => (
                      loading ? (
                        <Skeleton height="40px" width="70px" />
                      ) : (
                        <img
                          src={rowData.images?.[0] || rowData.matchedProductId?.images?.[0] || rowData.image}
                          alt="Product"
                          height="40"
                          width="70"
                          style={{ objectFit: "cover" }}
                          onError={(e) => {
                            const fallback = rowData.matchedProductId?.images?.[0];
                            if (fallback && e.target.src !== fallback) {
                              e.target.src = fallback;
                            } else {
                              e.target.style.display = "none";
                            }
                          }}
                        />
                      )
                    )}
                  />

                  {/* Product Title */}
                  <Column
                    field="title"
                    header="Product"
                    sortable
                    filter
                    style={{ width: "25%" }}
                    body={(rowData) => (
                      loading ? (
                        <Skeleton height="12px" width="80%" />
                      ) : (
                        <span
                          className="text-dark"
                          style={{ cursor: "pointer" }}
                          onClick={() => openDetailModal(rowData)}
                        >
                          {rowData.title}
                        </span>
                      )
                    )}
                  />

                  {/* Category */}
                  <Column
                    header="Category"
                    showFilterMenu={false}
                    sortable
                    sortField="_id"
                    style={{ width: "10%" }}
                    field="parentId"
                    filter
                    filterElement={representativeRowFilterTemplate}
                    body={(rowData) =>
                      loading ? (
                        <Skeleton height="12px" width="80%" />
                      ) : (
                        rowData.categoryId?.isParent?.title
                      )
                    }
                  />

                  {/* Sub Category */}
                  <Column
                    header="Sub Category"
                    sortable
                    sortField="categoryId"
                    field='categoryId'
                    filter
                    filterElement={representativeSubCategoryFilterTemplate}
                    style={{ width: "10%" }}
                    body={(rowData) =>
                      loading ? (
                        <Skeleton height="12px" width="80%" />
                      ) : (
                        rowData.categoryId?.title
                      )
                    }
                  />

                  {/* Amazon Price */}
                  <Column
                    field="amazonPrice"
                    header="Amazon"
                    sortable
                    style={{ width: "5%" }}
                    body={(rowData) => {
                      if (loading) return <Skeleton height="20px" width="60px" />;
                      const au = rowData.amazonUnitPrice, cu = rowData.carrefourUnitPrice;
                      const cheaper = (au && cu) ? au < cu : rowData.amazonPrice < rowData.carrefourPrice;
                      const color = !rowData.carrefourPrice ? "inherit" : cheaper ? "#16a34a" : "#dc2626";
                      return (
                        <a href={rowData.amazonLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                          <strong style={{ color }}>{rowData.amazonPrice ? `AED ${rowData.amazonPrice}` : "—"}</strong>
                          {au && <div style={{ fontSize: 11, color: "#888", fontWeight: 400 }}>AED {au}/L or kg</div>}
                        </a>
                      );
                    }}
                  />

                  {/* Carrefour Price */}
                  <Column
                    field="carrefourPrice"
                    header="Carrefour"
                    sortable
                    style={{ width: "5%" }}
                    body={(rowData) => {
                      if (loading) return <Skeleton height="20px" width="60px" />;
                      const au = rowData.amazonUnitPrice, cu = rowData.carrefourUnitPrice;
                      const cheaper = (au && cu) ? cu < au : rowData.carrefourPrice < rowData.amazonPrice;
                      const color = !rowData.amazonPrice ? "inherit" : cheaper ? "#16a34a" : "#dc2626";
                      return (
                        <a href={rowData.carrefourLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                          <strong style={{ color }}>{rowData.carrefourPrice ? `AED ${rowData.carrefourPrice}` : "—"}</strong>
                          {cu && <div style={{ fontSize: 11, color: "#888", fontWeight: 400 }}>AED {cu}/L or kg</div>}
                        </a>
                      );
                    }}
                  />

                  {/* Savings */}
                  <Column
                    field="savings"
                    header="Savings"
                    style={{ width: "5%" }}
                    body={(rowData) =>
                      loading ? (
                        <Skeleton height="20px" width="60px" />
                      ) : (
                        <strong>{rowData.savings}%</strong>
                      )
                    }
                  />

                  {/* Action */}
                  <Column
                    header="Action"
                    style={{ width: "20%" }}
                    body={(rowData) =>
                      loading ? (
                        <Skeleton height="30px" width="80px" />
                      ) : (
                        <Link className='btn btn-rounded btn-outline-secondary btn-small' onClick={() => openModal(rowData)}><i className="ri-edit-line"></i> Update Product Price </Link>
                      )
                    }
                  />

                </DataTable>
              </Row>
              {/* <Row className="mb-3">
                <Col md="12">
                  <div className='d-flex align-items-center gap-5'>
                    <div className='table-size-container'>
                      <span>Showing</span>
                      <select className='table-size-control' value={limit} onChange={(e) => { setLimit(Number(e.target.value)); fetchProducts(Number(e.target.value), 0, "") }}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                      <span>entries</span>
                    </div>
                    <div className="table-search-box">
                      <input type="search" id="customSearch" placeholder="Search Here..." ref={keywordRef} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchByKeyword(e); } }} />
                      <button disabled={loading} onClick={(e) => { searchByKeyword(e) }}><i className="ri-search-line"></i></button>
                    </div>
                    <div className="d-flex justify-content-end mb-3 gap-2" style={{ flex: 1 }}>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={handleExport}
                      >
                        <i className="ri-file-excel-2-fill me-1"></i> Export
                      </button>
                    </div>
                  </div>
                </Col>
              </Row> */}
              {/* <Row>
                <Col>
                  <Table>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>Image</th>

                        <th style={{ width: "25%" }} onClick={() => handleSort('title')}>
                          Product {sortKey === 'title' && (sortDirection === 'asc' ? '▲' : '▼')}
                        </th>

                        <th style={{ width: "10%" }} onClick={() => handleSort('isParent')}>
                          Category {sortKey === 'isParent' && (sortDirection === 'asc' ? '▲' : '▼')}
                        </th>

                        <th style={{ width: "10%" }} onClick={() => handleSort('categoryId')}>
                          Sub Category {sortKey === 'categoryId' && (sortDirection === 'asc' ? '▲' : '▼')}
                        </th>

                        <th style={{ width: "5%" }} onClick={() => handleSort('amazonPrice')}>
                          Amazon
                        </th>

                        <th style={{ width: "5%" }} onClick={() => handleSort('carrefourPrice')}>
                          Carrefour
                        </th>

                        <th style={{ width: "5%" }} onClick={() => handleSort('savings')}>
                          Savings
                        </th>

                        <th style={{ width: "10%" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(15)].map((a, i) => {
                            return <tr key={i}>
                              <td className='w-20'><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                              <td className='w-30'><Skeleton height={12} width={80} /></td>
                              <td className='w-30'><Skeleton height={12} width={80} /></td>
                              <td className='w-30'><Skeleton height={12} width={80} /></td>
                              <td className='w-15'><Skeleton height={20} width={60} /></td>
                              <td className='w-15'><Skeleton height={30} width={60} /></td>
                              <td className='w-15'><Skeleton height={30} width={60} /></td>
                              <td className='w-15'><Skeleton height={30} width={60} /></td>
                            </tr>
                          }) :
                          !products.length ?
                            <tr><td colSpan="4" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No products found</span></td></tr> :
                            products.map((item, i) => (
                              <tr key={i} >
                                <td className='w-20'><Image src={item.images.length ? item.images[0] : item.image} alt="Banner" className='me-2' height='40px' width='70px' objectFit='cover' /></td>
                                <td className='w-30' onClick={() => openDetailModal(item)}><span className='text-dark'>{item.title}</span></td>
                                <td className='w-30'>{item.categoryId.isParent.title}</td>
                                <td className='w-30'>{item.categoryId.title}</td>
                                <td className='w-15'><a href={item.amazonLink} target='_blank' className='text-dark text-decoration-none'><strong>AED {item.amazonPrice}/-</strong></a></td>
                                <td className='w-15'><a href={item.carrefourLink} target='_blank' className='text-dark text-decoration-none'><strong>AED {item.carrefourPrice}/-</strong></a></td>
                                <td className='w-15'><strong>{item.savings}%</strong></td>
                                <td>
                                  <Link className='btn btn-rounded btn-outline-secondary btn-small' onClick={() => openModal(item)}><i className="ri-edit-line"></i> Get Carrefour Products</Link>
                                </td>
                              </tr>
                            ))
                      }
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <TablePagination limit={limit} page={page} currentRecords={products.length} total={count} loading={false} onPaginationChange={(p) => onPaginationChange(p)} /> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <CarrefourModal
        visible={modalVisible}
        onClose={() => { setModalVisible(false); fetchProducts(lazyParams); }}
        item={selectedItem}
        loading={detailTableLoading}
      />

      {/* add a modal for technical details */}
      <Modal
        isOpen={visible}
        onRequestClose={() => setVisible(false)}
        contentLabel="Product Details"
        style={{
          overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "1400px",
            borderRadius: "10px",
            padding: "20px",
            overflow: "hidden"
          },
        }}
      >
        <button className='btn btn-rounded btn-outline-secondary mb-3' style={{ float: "right" }} onClick={() => setVisible(false)}>X</button>
        <Table>
          <thead>
            <tr>
              <th className='w-20' colSpan={2}>General Information  <span className='ms-2'>({technicalDetails.title})L</span></th>
            </tr>
          </thead>
          <tbody>
            {
              loading ?
                [...Array(2)].map((a, i) => {
                  return <tr key={i}>
                    <td className='w-20'><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                    <td className='w-30'><Skeleton height={12} width={80} /></td>
                  </tr>
                }) :
                (!technicalDetails.technicalDetails || Object.entries(technicalDetails.technicalDetails).length === 0) ?
                  <tr><td colSpan="2" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No products found</span></td></tr> :



                  Object.entries(technicalDetails.technicalDetails)
                    .filter(([key, value]) =>
                      key.toLowerCase().includes("brand") ||
                      key.toLowerCase().includes("size") ||
                      key.toLowerCase().includes("weight") ||
                      key.toLowerCase().includes("unit count") ||
                      key.toLowerCase().includes("dimensions") ||
                      key.toLowerCase().includes("material") ||
                      key.toLowerCase().includes("model number") ||
                      key.toLowerCase().includes("manufacturer")
                    )
                    .map(([key, value]) => (
                      <tr key={key}>
                        <td className='w-20'>{key}</td>
                        <td className='w-50'>{value}</td>
                      </tr>
                    ))
            }
          </tbody>
        </Table>
      </Modal>
    </Container>
  );
}
